export default [
    {
        path: "/portais",
        name: "Portais",
        component: () => import("../views/Portais"),
        meta: { requiresAuth: true },
    },
    {
        path: "/portal/:idPortal/logins",
        name: "Logins",
        component: () => import("../views/Logins"),
        meta: { requiresAuth: true },
    }
]